import { render, staticRenderFns } from "./dot-overlay.vue?vue&type=template&id=3b081700&scoped=true&"
import script from "./dot-overlay.vue?vue&type=script&lang=js&"
export * from "./dot-overlay.vue?vue&type=script&lang=js&"
import style0 from "./dot-overlay.vue?vue&type=style&index=0&id=3b081700&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b081700",
  null
  
)

export default component.exports